import { h, Component } from 'preact';
import style from './style';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

import { route } from 'preact-router';

import { apiGetRequest, apiPostRequest } from '../../../components/utils/api';

export default class TeamJoin extends Component {
	constructor(props) {
		super(props);
		this.state = {
            name: "",
            email: "",
            password: "",
            errors: [],
            loading: true,
            team_name: ""
		}
	}

	handleChange(key, value) {
		let state = this.state;
		state[key] = value;
		this.setState(state);
	}

	handleSubmit(e) {
		e.preventDefault();
		var postData = {
            first_name: this.state.name,
            username: this.state.email,
            password: this.state.password,
            token: this.props.token
		};

		apiPostRequest("teams/join/", postData).then((data) => {
			console.log(data);
			if (data.key) {
				this.props.changeAuthToken(data.key);
                this.props.changeAuthenticationStatus(true);
                location.reload();
			} else if (data.error) {
                this.setState({errors: [data.error]});
            }
		}).catch((error) => {
            console.log(error);
            this.setState({errors: [error.error]})
        })
    }
    
    checkToken() {
        apiPostRequest("teams/check-token/", {token: this.props.token}).then((data) => {
            console.log(data);
            if (data.ok) {
                this.setState({loading: false, team_name: data.team_name});
            } else {
                route("/", true);
            }
        }).catch((error) => {
            console.log(error);
            route("/", true);
        })
    }

    componentDidMount() {
        this.checkToken();
    }

	render() {
        if (this.state.loading) {
            
        } else {
            return (
                <div class={cx("home")}>
                    <div class={cx("content-container")}>
                        <h2 class={cx("headline")} style={{marginBottom: "auto"}}>Welcome to {this.state.team_name}</h2>
                        <form class={cx("register-form")} onSubmit={(e) => this.handleSubmit(e)} style={{marginBottom: "auto"}}>
                            <label>
                                Name
                                <input 
                                    state={this.state.name}
                                    onInput={(e) => this.handleChange("name", e.target.value)}
                                    required
                                    type="text"
                                />
                            </label>
                            <label>
                                Email
                                <input 
                                    state={this.state.email}
                                    onInput={(e) => this.handleChange("email", e.target.value)}
                                    required
                                    type="email"
                                />
                            </label>
                            <label>
                                Password
                                <input 
                                    state={this.state.password}
                                    onInput={(e) => this.handleChange("password", e.target.value)}
                                    required
                                    type="password"
                                />
                            </label>
                            <button type="submit" class={cx("button")}>
                                <p>Join</p>
                            </button>
                            {this.state.errors.map((item) => {
                                return <p style={{color: 'red'}}>{item}</p>
                            })}
                        </form>
                    </div>
                </div>
            )
        }

	}
}




// WEBPACK FOOTER //
// ./routes/teams/teamJoin/index.js